module.exports = __webpack_public_path__ + "static/media/roanokeskyline.22c112c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/roanokeskyline.jpg
// module id = 737
// module chunks = 0